import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { MatTabsModule } from '@angular/material/tabs';
import { RouterModule } from '@angular/router';
import { FeatureInfoComponent } from '@principle-theorem/ng-feature-flags';
import {
  BreadcrumbsComponent,
  IBreadcrumb,
} from '@principle-theorem/ng-shared';

@Component({
  selector: 'pr-reporting-navigation',
  templateUrl: './reporting-navigation.component.html',
  styleUrls: ['./reporting-navigation.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    BreadcrumbsComponent,
    CommonModule,
    FeatureInfoComponent,
    MatTabsModule,
    RouterModule,
  ],
})
export class ReportingNavigationComponent {
  breadcrumbs: IBreadcrumb[] = [
    { label: 'Reporting' },
    { label: 'Custom Reports' },
  ];
  navLinks: IBreadcrumb[] = [
    { label: 'Published Custom Reports', path: ['./custom-reports'] },
    { label: 'Draft Custom Reports', path: ['./custom-reports/draft'] },
    { label: 'Managed Reports', path: ['./managed-reports'] },
  ];
}
